export default "__VITE_ASSET__dfd317c4__"